import { useState } from "react";
import { createPortal } from 'react-dom';
import {
  Navbar,
  Nav,
  NavItems,
  NavItem,
  NavLink,
  ButtonLink,
  DropdownMenu,
  DropdownItem,
  SubNavLink,
  Caret,
} from "./styles";
import Icon from "../../../../Icon";
import constants from "../../../../../constants";
import { connect, useDispatch } from "react-redux";
import { Dispatch, Action } from "redux";
import { UserDto } from "../../../../../types/user.dto";

import CaretDown from "../../../../../assets/icons/caret-down.svg";

interface ComponentProps {
  user: UserDto;
}


const Component = ({ user }: ComponentProps) => {
  const [activeDropdown, setActiveDropdown] = useState<string>();
  const [activeDropdownChildren, setActiveDropdownChildren] =
    useState<string>();
  const dispatch = useDispatch<Dispatch<Action>>();

  const footerSticky = document.getElementById("footer-sticky") as HTMLElement;

  if (!footerSticky) {
    throw new Error("Element with id 'footer-sticky' not found in the document");
  }

  return (
    createPortal(
      <Navbar>
        <Nav>
          <NavItems>
            <>
              {constants.menu.mobileMenu.map((menuItem, menuIndex) => {
                const hasChildren =
                  !!menuItem.children && menuItem.children?.length > 0;
                const isActiveDropdown =
                  menuItem.link === activeDropdown ||
                  menuItem.link === activeDropdownChildren;
                return (
                  <NavItem key={`menu-${menuIndex}`}>
                    {hasChildren ? (
                      <ButtonLink
                        onClick={(event) => {
                          setActiveDropdown(
                            isActiveDropdown ? "" : menuItem.link
                          );
                        }}
                        className={isActiveDropdown ? "active" : ""}
                      >
                        <span>
                          {!!menuItem.icon && (
                            <Icon
                              icon={menuItem.icon}
                              color="#FFFFFF"
                              size="22px"
                            />
                          )}

                          <span>{menuItem.title}</span>
                        </span>

                        {hasChildren && (
                          <Caret className="caret">
                            <Icon icon={CaretDown} color="#FFFFFF" size="22px" />
                          </Caret>
                        )}
                      </ButtonLink>
                    ) : (
                      <NavLink
                        className={({ isActive }) =>
                          isActive ? "active" : undefined
                        }
                        to={`/dashboard${menuItem.link}`}
                        onClick={() => {
                          setActiveDropdown("");
                          setActiveDropdownChildren(menuItem.link);
                        }}
                      >
                        <span>
                          {!!menuItem.icon && (
                            <Icon
                              icon={menuItem.icon}
                              color="#FFFFFF"
                              size="22px"
                            />
                          )}

                          <span>{menuItem.title}</span>
                        </span>

                        {hasChildren && (
                          <Caret className="caret">
                            <Icon icon={CaretDown} color="#FFFFFF" size="22px" />
                          </Caret>
                        )}
                      </NavLink>
                    )}

                    {hasChildren && (
                      <DropdownMenu
                        amountItems={menuItem.children?.length}
                        isActiveDropdown={isActiveDropdown}
                      >
                        {menuItem.children?.map((submenuItem, submenuIndex) => (
                          <DropdownItem key={`submenu-item-${submenuIndex}`}>
                            <SubNavLink
                              className={({ isActive }) =>
                                isActive ? "active" : undefined
                              }
                              onClick={() =>
                                setActiveDropdownChildren(menuItem.link)
                              }
                              to={`/dashboard${menuItem.link}${submenuItem.link}`}
                            >
                              {submenuItem.title}
                            </SubNavLink>
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    )}
                  </NavItem>
                );
              })}
            </>
          </NavItems>
        </Nav>
      </Navbar>,
      footerSticky
    )
  );
};

const states = ({ userStore }) => {
  const { data: user } = userStore;
  return {
    user,
  };
};

export default connect(states)(Component);
